import './App.css';
// import './styles/custom.css'; // Importing Bootstrap custom CSS
// import 'bootstrap/dist/js/bootstrap.bundle.min'; // Importing Bootstrap JS
import 'font-awesome/css/font-awesome.min.css';

import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider } from './context/ThemeContext';

import LandingPage from './pages/LandingPage';
import Home from './pages/Home';
import Bookmarks from './pages/Bookmarks';
import Details from './pages/Details'; 
import ViewAll from './pages/ViewAll'; 

import '@mantine/core/styles.css';
// import '@mantine/carousel/styles.css';

import { MantineProvider } from '@mantine/core';

function App() {
  return (
    <MantineProvider>
      <div className='dark:bg-black bg-gray-100'>
        <BrowserRouter>
          <ThemeProvider>

            <Routes>
              {/* Landing page */}
              <Route path="/" element={<LandingPage />} />

              {/* application routes */}
              <Route path="/home" element={<Home />} />
              <Route path="/bookmarks" element={<Bookmarks />} />
              
              {/* New routes for details */}
              <Route path="/details/:type/:id" element={<Details />} />

              {/* ViewAll routes: with and without page param */}
              <Route path="/:category/:page" element={<ViewAll />} />
              <Route path="/:category" element={<ViewAll />} />
            </Routes>

          </ThemeProvider>
        </BrowserRouter>

      </div>
    </MantineProvider>
  );
}

export default App;
